
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-f1a47814&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./homepagezxgs.vue")
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-f1a47814&scoped=true!less-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./homepagezxgs.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./homepagezxgs.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-f1a47814!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./homepagezxgs.vue"),
  /* scopeId */
  "data-v-f1a47814",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/storeManagement/homepagezxgs.vue
// module id = 1594
// module chunks = 3